import React, { Component } from 'react';

class Banner extends Component {
  render() {
    return (
      <section id="banner">
        <div className="inner">
          {/* <span className="icon fa-laptop"></span> */}
          <img className="img-fluid" alt="PDFiber Logo" src="images/PDFiberLogo_Web.png" />
          <h1>Gigabit Fiber Optic Internet, Phone and High Definition Television</h1>
          <ul className="actions">
            <li><a href="#one" className="button wide scrolly">Documents and Services</a></li>
          </ul>
        </div>
      </section>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.js